import React from 'react';
import { useTranslation } from 'react-i18next';
import DeviationSelector from '..';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import SelectedItemsPanel from '../../../_partials/SelectedItemsPanel';
import PopupInnerLayout from '../../../_partials/PopupInnerLayout';
import Flex from '@wix/da-ds/pkg/Flex';
import { useCurrentTierDeviations } from '../../../_hocs/withCurrentTierDeviations';
const TierDeviationSelector = ()=>{
    const { isInitialized, isFetching, fetchMoreTierDeviations, hasMore, deviations } = useCurrentTierDeviations();
    const { t } = useTranslation();
    const renderEmpty = ()=>{
        return /*#__PURE__*/ React.createElement(Flex, {
            fullWidth: true,
            fullHeight: true,
            direction: "column",
            justifyContent: "center",
            alignItems: "center"
        }, t('mediapopup.empty.tier'));
    };
    const renderContent = ()=>{
        return /*#__PURE__*/ React.createElement(React.Fragment, null, isInitialized && (!deviations.length && !isFetching && !hasMore ? renderEmpty() : /*#__PURE__*/ React.createElement(DeviationSelector, {
            deviations: deviations
        })), (!isInitialized || isFetching) && /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: "daSymbol",
            coverMode: !hasMore && !isFetching
        }));
    };
    const fetchMoreTierDeviationsIfNeeded = ()=>{
        if (!hasMore || isFetching) {
            return;
        }
        fetchMoreTierDeviations();
    };
    return /*#__PURE__*/ React.createElement(PopupInnerLayout, {
        headerExtrasBottomZone: /*#__PURE__*/ React.createElement(SelectedItemsPanel, null),
        scrollableContent: renderContent(),
        onScrolledToBottom: fetchMoreTierDeviationsIfNeeded,
        onNotScrollable: fetchMoreTierDeviationsIfNeeded
    });
};
TierDeviationSelector.displayName = 'TierDeviationSelector';
export default TierDeviationSelector;
